<label class="switch-button" (click)="handleClick()">
  <input type="checkbox" [checked]="checked" [disabled]="isDisabled" />
  <span></span>
  <strong *ngIf="label">{{ label }}</strong>
</label>
